var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.loading ? _c('p', [_c('Loading')], 1) : _vm._e(), _c('div', {
    staticClass: "s-p-3"
  }, [_c('div', {
    staticClass: "reward__title py-3"
  }, [_vm._v(_vm._s(_vm.rewardMission.title))]), _vm.status == 'init' ? _c('b-card', {
    staticClass: "reward fail p-4 mb-4",
    attrs: {
      "no-body": ""
    }
  }, [_c('div', {
    staticClass: "reward__stamp my-4"
  }, [_c('img', {
    attrs: {
      "src": require("./images/stamp.svg")
    }
  })])]) : _vm._e(), _vm.status == 'success' ? _c('b-card', {
    staticClass: "reward success p-4 mb-4",
    attrs: {
      "no-body": ""
    }
  }, [_c('div', {
    staticClass: "reward__stamp my-4"
  }, [_c('img', {
    attrs: {
      "src": require("./images/stamp.svg")
    }
  })]), _c('div', {
    staticClass: "reward__result my-3"
  }, [_vm._v("集點成功")]), _c('div', {
    staticClass: "reward__message"
  }, [_vm._v(" 恭喜您獲得 "), _c('span', {
    staticClass: "s-text-primary"
  }, [_vm._v(_vm._s(_vm.earnPoint))]), _vm._v(" 點 "), _vm.isAtLimit ? _c('span', [_vm._v("(已達集點上限)")]) : _vm._e()])]) : _vm._e(), _vm.status == 'fail' ? _c('b-card', {
    staticClass: "reward fail p-4 mb-4",
    attrs: {
      "no-body": ""
    }
  }, [_c('div', {
    staticClass: "reward__stamp my-4"
  }, [_c('img', {
    attrs: {
      "src": require("./images/stamp.svg")
    }
  })]), _c('div', {
    staticClass: "reward__result my-3"
  }, [_vm._v("集點失敗")]), _c('div', {
    staticClass: "reward__message"
  }, [_vm._v(_vm._s(_vm.errorMsg))])]) : _vm._e(), _vm.showConfirmButton ? _c('button', {
    staticClass: "s-btn s-liff-theme-btn-outline mb-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showBranchCodeForm
    }
  }, [_vm._v("重新核銷")]) : _vm._e(), _vm.status != 'init' ? _c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'LiffRewardsCardHome',
          params: {
            rewardsCardId: _vm.rewardMission.reward_card_id
          }
        });
      }
    }
  }, [_vm._v(" 前往集點卡 ")]) : _vm._e()], 1), _c('Popup', {
    ref: "selectBranchPopup",
    attrs: {
      "title": "請選擇分店",
      "panelHeight": "auto",
      "show-close": false
    }
  }, [_c('ShopSelection', {
    ref: "shopSelection",
    attrs: {
      "branch-provider": _vm.branchProvider
    },
    on: {
      "loading": function loading($event) {
        _vm.fetching = true;
      },
      "loaded": function loaded($event) {
        _vm.fetching = false;
      }
    },
    model: {
      value: _vm.branchId,
      callback: function callback($$v) {
        _vm.branchId = $$v;
      },
      expression: "branchId"
    }
  }), _c('div', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('button', {
    staticClass: "s-btn s-liff-theme-btn s-btn-sm",
    attrs: {
      "type": "button",
      "disabled": !_vm.branchId
    },
    on: {
      "click": _vm.handleSelectBranch
    }
  }, [_vm._v(" 確定 ")])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }